import {
  Cake,
  FileText,
  Image,
  RefreshCw,
  Lock,
  Percent,
  Video,
  Volume2,
  QrCode,
  Code,
  FileDown,
  Calendar,
  PawPrint,
  CheckCircle,
  Users,
  Moon,
  Wallet,
  HeartPulse,
  Baby,
  TrendingUp, TrendingDown, Tag, Receipt, HandCoins, GraduationCap, Award,
} from 'lucide-react'

export const TOOLS = [
  {
    id: 'age',
    name: 'Age Calculator',
    description: 'Calculate your exact age in years, months, days, and more',
    path: '/age/',
    icon: Cake
  },
  {
    id: 'chronological-age-calculator',
    name: 'Chronological Age',
    description: 'Calculate age for testing and psychological assessment purposes',
    path: '/chronological-age-calculator/',
    icon: Calendar
  },
  {
    id: 'pet-age-calculator',
    name: 'Pet Age',
    description: 'Convert your dog or cat\'s age into human years',
    path: '/pet-age-calculator/',
    icon: PawPrint
  },
  {
    id: 'eligibility-calculator',
    name: 'Eligibility Check',
    description: 'Check exam (CSS/PPSC/FPSC) and life milestone age eligibility',
    path: '/eligibility-calculator/',
    icon: CheckCircle
  },
  {
    id: 'generation-calculator',
    name: 'Generation Finder',
    description: 'Find your generation and see your life in weeks',
    path: '/generation-calculator/',
    icon: Users
  },
  {
    id: 'islamic-age-calculator',
    name: 'Islamic Age',
    description: 'Calculate your age in the Hijri (Islamic) calendar',
    path: '/islamic-age-calculator/',
    icon: Moon
  },
  {
    id: 'retirement-age-calculator',
    name: 'Retirement Age',
    description: 'Estimate your retirement date based on your target age',
    path: '/retirement-age-calculator/',
    icon: Wallet
  },


  {
    id: 'word-counter',
    name: 'Word Counter',
    description: 'Count words, characters, sentences, and analyze text statistics',
    path: '/word-counter/',
    icon: FileText
  },
  {
    id: 'image-compressor',
    name: 'Image Compressor',
    description: 'Compress images without losing quality',
    path: '/image-compressor/',
    icon: Image
  },
  {
    id: 'image-converter',
    name: 'Image Converter',
    description: 'Convert images between different formats',
    path: '/image-converter/',
    icon: RefreshCw
  },
  {
    id: 'password',
    name: 'Password Generator',
    description: 'Generate strong and secure passwords',
    path: '/password/',
    icon: Lock
  },
  {
    id: 'percentage',
    name: 'Percentage Calculator',
    description: 'Calculate percentages and percentage changes',
    path: '/percentage/',
    icon: Percent
  },
  {
    id: 'yt-thumbnail',
    name: 'YouTube Thumbnail',
    description: 'Download YouTube video thumbnails',
    path: '/yt-thumbnail/',
    icon: Video
  },
  {
    id: 'text-to-speech',
    name: 'Text to Speech',
    description: 'Convert text to natural speech',
    path: '/text-to-speech/',
    icon: Volume2
  },
  {
    id: 'qr-generator',
    name: 'QR Code Generator',
    description: 'Generate QR codes for text and URLs',
    path: '/qr-generator/',
    icon: QrCode
  },
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    description: 'Format, validate, and beautify JSON data',
    path: '/json-formatter/',
    icon: Code
  },
  {
    id: 'percentage-increase-calculator',
    name: 'Percentage Increase',
    description: 'Find the percentage increase between two values, or add a percentage to a number',
    path: '/percentage-increase-calculator/',
    icon: TrendingUp
  },
  {
    id: 'percentage-decrease-calculator',
    name: 'Percentage Decrease',
    description: 'Find the percentage decrease between two values, or apply a decrease',
    path: '/percentage-decrease-calculator/',
    icon: TrendingDown
  },
  {
    id: 'discount-calculator',
    name: 'Discount Calculator',
    description: 'Calculate sale price, savings, and original price from a discount',
    path: '/discount-calculator/',
    icon: Tag
  },
  {
    id: 'tax-calculator',
    name: 'Tax Calculator',
    description: 'Calculate sales tax and total amount on a purchase',
    path: '/tax-calculator/',
    icon: Receipt
  },
  {
    id: 'tip-calculator',
    name: 'Tip Calculator',
    description: 'Calculate tip and split the bill among any number of people',
    path: '/tip-calculator/',
    icon: HandCoins
  },
  {
    id: 'marks-percentage-calculator',
    name: 'Marks Percentage',
    description: 'Calculate exam marks percentage, grade, and division',
    path: '/marks-percentage-calculator/',
    icon: GraduationCap
  },
  {
    id: 'gpa-calculator',
    name: 'GPA / CGPA Calculator',
    description: 'Calculate semester SGPA, cumulative CGPA, and required GPA',
    path: '/gpa-calculator/',
    icon: Award
  },
  // {
  //   id: 'document-converter',
  //   name: 'Document Converter',
  //   description: 'Convert documents between PDF, Word, Excel, PowerPoint and more formats',
  //   path: '/document-converter/',
  //   icon: FileDown
  // }
]